export default "__VITE_ASSET__4EVDMAPD__"